import { render, staticRenderFns } from "./InstantDashboard.vue?vue&type=template&id=2d0147d7&scoped=true&"
import script from "./InstantDashboard.vue?vue&type=script&lang=js&"
export * from "./InstantDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InstantDashboard.vue?vue&type=style&index=0&id=2d0147d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0147d7",
  null
  
)

export default component.exports